var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 382.933,
    y: 73.6,
    style: {
      fill: "#F05540"
    },
    width: 58.667,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.533,
    y: 21.333,
    style: {
      fill: "#F3705A"
    },
    width: 103.467,
    height: 55.467
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M44.8,276.267V512h418.133V276.267c-82.133-82.133-128-128-209.067-209.067l0,0 C172.8,149.333,126.933,195.2,44.8,276.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B64C"
    },
    d: "M464,276.267c-82.133-82.133-128-128-209.067-209.067c-41.6,40.533-73.6,72.533-105.6,104.533 s-64,64-104.533,104.533v48c82.133-82.133,128-128,209.067-209.067c82.133,82.133,128,128,209.067,209.067v6.4l0,0v-54.4H464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M216.533,512H90.667V388.267c0-35.2,28.8-62.933,62.933-62.933l0,0c35.2,0,62.933,28.8,62.933,62.933 V512z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.867,
    y: 325.333,
    style: {
      fill: "#344A5E"
    },
    width: 164.267,
    height: 144
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 270.933,
    y: 342.4,
    style: {
      fill: "#8AD7F8"
    },
    width: 56.533,
    height: 109.867
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.533,
    y: 342.4,
    style: {
      fill: "#8AD7F8"
    },
    width: 56.533,
    height: 109.867
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3705A"
    },
    d: "M502.4,232.533L279.467,9.6c-12.8-12.8-35.2-12.8-48,0L9.6,232.533c-12.8,12.8-12.8,35.2,0,48 c12.8,12.8,35.2,12.8,48,0L256,82.133l198.4,198.4c12.8,12.8,35.2,12.8,48,0C515.2,266.667,515.2,245.333,502.4,232.533z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.f6fe9c3f0de9efb7cb7b8381ad3e8017.svg";
export { ForwardRef as ReactComponent };